import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesUptVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesUptVillagePages;
